import { connect } from "react-redux";
import PmSitesCheckList from "./pmSitesCheckList";
import { bindActionCreators } from "redux";
import {
  fetchgetSiteGates,sendForApproval,getScheduledTicket
} from "services/redux/maintenance/pmList/action";

import {getSiteState} from "../../../services/redux/brandActivtion/sitesListing/action";
import {getSiteData, calculateDistance, getDistanceData, generateHappyCodePM, refreshAfterSiteCheckout} from "../../../services/redux/DistanceCalculator/action";

import {
  getLocationApprovalPending,getCheckLocation
} from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
  pmGateData: state.pmListReducer.pmGateData,
  scheduledTickets:  state.pmListReducer.scheduledTickets,
  locationApproval: state.siteInspectionReducer.locationApproval,
  locationCheck : state.siteInspectionReducer.locationCheck,
  siteEnableDisable: state.baSiteListingReducer.siteEnableDisable,
  siteData: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  activeDistanceCheckin: state.loginReducer?.userProfile?.active_distance_checkin || null,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchgetSiteGates,
      sendForApproval,
      getScheduledTicket,
      getLocationApprovalPending,
      getCheckLocation,
      getSiteState,
      getSiteData,
      calculateDistance,
      getDistanceData,
      generateHappyCodePM,
      refreshAfterSiteCheckout
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmSitesCheckList);
